import {
  ErrorReporter,
  patchConsoleError,
  patchStackdriverErrorReporter,
} from "@kaggle/core";
import {
  featureFlags,
  getSessionClaims,
  getSessionTokenFromCookie,
} from "@kaggle/sdk";
// @ts-ignore
import StackdriverErrorReporter from "stackdriver-errors-js";

let errorReporter: ErrorReporter;

function isErrorReporterDisabled() {
  return (
    !featureFlags.frontendErrorReporting ||
    process.env.NODE_ENV === "development"
  );
}

export function startErrorReporter() {
  if (isErrorReporterDisabled()) {
    return;
  }
  const sessionClaims = getSessionClaims(getSessionTokenFromCookie());

  if (sessionClaims) {
    const versionModifier = "sessionless";

    try {
      errorReporter = new StackdriverErrorReporter();
      patchStackdriverErrorReporter(errorReporter);
      if (featureFlags.frontendConsoleErrorReporting) {
        patchConsoleError(errorReporter);
      }

      errorReporter.start({
        key: sessionClaims.sdak,
        projectId: sessionClaims.pid,
        service: sessionClaims.svc,
        version: `ci-${versionModifier}`,
        context: {
          user: sessionClaims.uid?.toString(),
        },
      });
    } catch (err) {
      // tslint:disable-next-line:no-console
      console.error("Failed to start Stackdriver Error Reporter: " + err);
    }
  } else {
    // tslint:disable-next-line:no-console
    errorReporter = { report: console.error };
  }
}

export function getErrorReporter(): ErrorReporter | null {
  if (isErrorReporterDisabled()) {
    return null;
  }
  if (!errorReporter) {
    startErrorReporter();
  }
  return errorReporter;
}
